import { createFileRoute } from '@tanstack/react-router';
import Jumio from 'pages/jumio/jumio.component';

export const Route = createFileRoute('/_auth/upload-document')({
  component: Jumio,
});
